import { render, staticRenderFns } from "./ModalOptins.vue?vue&type=template&id=5ec5db2c"
import script from "./ModalOptins.vue?vue&type=script&lang=js"
export * from "./ModalOptins.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports